// components/guards/RequireOrgManager.jsx
import React, { useEffect, useState } from 'react';
import { Navigate, useParams, useLocation } from 'react-router-dom';
import { assertAdmin } from '../../api/organizationApi';
import { useToast } from '../../components/Toaster/use-toast';

export default function RequireOrgManager({ children, redirectTo = '/conversation-type' }) {
  const { orgId: orgIdParam } = useParams();
  const orgId = Number(orgIdParam);
  const location = useLocation();
  const { toast } = useToast();
  const [allowed, setAllowed] = useState(null); // null=loading

  useEffect(() => {
    let alive = true;

    (async () => {
      if (!orgId || Number.isNaN(orgId)) {
        if (alive) setAllowed(false);
        return;
      }
      try {
        await assertAdmin(orgId); // 204 => OK
        if (alive) setAllowed(true);
      } catch {
        if (alive) setAllowed(false);
        toast({
          title: 'Access restricted',
          description: 'Managers of this organization only.',
          variant: 'warning',
        });
      }
    })();

    return () => { alive = false; };
  }, [orgId, toast]);

  if (allowed === null) return null; // optional: small spinner
  return allowed
    ? children
    : <Navigate to={redirectTo} replace state={{ from: location }} />;
}
